module.exports = __webpack_public_path__ + "static/media/sp10.91663646.JPG";